import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import img from "./hero.png";

const Introduction = ({ data, index }) => {
  // console.log("data_intro:====>>", data[index]?.introduction?.im);
  //  console.log("data_intro:====>>", data[index]?.introduction?.title);
  //   console.log("data_intro:====>>", data[index]?.introduction?.title);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        // border: "1px solid red",
        backgroundColor: "#f5f5f7",
        height: "100%",
      }}
    >
      <Stack
        sx={{
          height: { xs: "100%", sm: "100%" },
          width: { xs: "100%", sm: "60%" },
          // border: "1px solid red",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          // src={img}
          src={data[index]?.introduction?.img || img}
          alt="img"
          style={{ height: "100%", width: "100%" }}
        />
      </Stack>
      <Stack
        sx={{
          height: "100%",
          width: { xs: "100%", sm: "35%" },
          // border: "1px solid blue",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            height: "auto",
            width: "100%",
            // border: "2px solid green",
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Stack
            sx={{
              lineHeight: {
                lg: "48px",
                xl: "48px",
                md: "32px",
                xs: "24px",
                sm: "24px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "40px",
                xl: "40px",
                md: "28px",
                xs: "20px",
                sm: "20px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 600,
                xl: 600,
                xs: 600,
                sm: 600,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: { xs: "4px", sm: "12px" },
              paddingLeft: { xs: "14px", sm: "12px" },
              // paddingRight: "12px",
              // border: "1px solid red",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
            }}
          >
            {data[index]?.introduction?.title || "title"}
            {/* Unlock digital success for your business with all-in-one SaaS
            solution! */}
          </Stack>

          <Stack
            sx={{
              width: "100%",
              fontFamily: "'Roboto', sans-serif",
              fontSize: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "24px",
                xl: "24px",
              },
              lineHeight: {
                xs: "24px",
                sm: "28px",
                md: "32px",
                lg: "32px",
                xl: "32px",
              },
              fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
              color: "#333",
              border: "1px solid #f1f8ff",
              textAlign: "left",
              // border: "1px solid blue",
              // border: "1px solid red",
              padding: { xs: 0, sm: 2 },
              paddingLeft: { xs: 2, sm: 2 },
              borderRadius: "8px",
              backgroundColor: "#f1f8ff",
              marginBottom: {
                xs: "8px",
                sm: "0px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
            }}
          >
            {data[index]?.introduction?.description || "description"} 
           
            {/* Seamlessly integrate with multiple apps and maximize your brand's
            digital potential. Drive data-driven growth and achieve unparalleled
            success with Vertex Suite */}
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              padding: { xs: "0px", sm: "12px" },
              marginBottom: { xs: "20px", sm: "0px" },
              marginLeft: { xs: "12px", sm: "0px" },
              // border: "1px solid blue",
            }}
          >
            <Button
              variant="contained"
              size="medium"
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                // Initial background
                color: "white", // Text color
                backgroundColor: "rgb(5, 78, 146)",
                borderColor: "rgb(5, 78, 146)", // Border same as background
                boxShadow:
                  "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                "&:hover": {
                  backgroundColor: "rgb(31, 133, 192)", // Hover background
                  borderColor: "rgb(31, 133, 192)", // Hover border
                },
              }}
            >
              Schedule demo
            </Button>{" "}
            <Button
              variant="outlined"
              size="medium"
              sx={{
                textTransform: "none",
                borderRadius: "8px",

                color: "rgb(5, 78, 146)", // Text color
                borderColor: "rgb(5, 78, 146)", // Border same as background
                boxShadow:
                  "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                "&:hover": {
                  borderColor: "rgb(31, 133, 192)", // Hover border
                },
              }}
            >
              Login
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Introduction;
